export default __webpack_public_path__ + "static/media/odznaka-3.0efae76e.svg";